/* @flow */
/**
 * External dependencies
 */
import { isEmpty } from 'lodash';

export const setDoneState = ( state: Object ) : Object => {
	if ( isEmpty( state ) ) {
		return state;
	}

	if ( state.user.track && state.user.progress.init !== 'done' ) {
		state.user.progress.init = 'done';
	}

	return state;
};



// WEBPACK FOOTER //
// ./shared/state.js